import React from 'react'
import PropTypes from 'prop-types'

export default function RenderIf({ isTrue, children }) {
  if (isTrue) {
    return <>{children}</>
  }
  return null
}

RenderIf.propTypes = {
  isTrue: PropTypes.oneOfType([PropTypes.any]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.shape,
    PropTypes.node,
  ]),
}

RenderIf.defaultProps = {
  isTrue: false,
  children: [],
}
